<template>
  <div
    v-loading="isLoading"
    class="pricing-block">
    <OnboardingPageHeader
      :page-title="$t('pages.onboarding.shared.plan.title')"
      show-stage/>
    <div
      v-if="pricingFields"
      class="pricing-table">
      <PricingSection
        :fields="pricingFields"/>
      <a
        v-if="pricingHref"
        :href="pricingHref"
        target="_blank"
        class="-colored pt-24 gap-4 flex flex-row justify-center items-center">
        {{ $t('action.show_full_pricing') }}
        <img
          :src="linkIcon"
          :alt="''">
      </a>
    </div>
    <div
      v-show="!isLoading"
      class="pricing-footer">
      <FormKit
        type="form"
        form-class="m-0 p-0"
        :submit-label="$t('action.send_application')"
        @submit="onAccept()">
        <template #actions>
          <FormKit
            type="submit"
            input-class="px-52 w-320"
            :label="$t('action.send_application')"/>
        </template>
      </FormKit>

      <div class="pricing-footer-agreement">
        <p>{{ $t('pages.onboarding.shared.plan.agreement') }}</p>
        <a
          class="text-blue-70 underline"
          :href="agreementHref"
          target="_blank">
          {{ agreementLabel }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

import linkIcon from '@/assets/icons/link-external.svg';
import OnboardingPageHeader from '@/modules/onboarding/components/OnboardingPageHeader.vue';
import { orderByType } from '@/modules/pricing/adapter/orderByType';
import PricingSection from '@/modules/pricing/components/PricingSection.vue';
import { requestHandler } from '@/services/requestHandler';
import { UsersRequests } from '@/services/requests';
import { ContractPricing } from '@/services/requests/users/Users.types';

defineProps<{
  agreementLabel: string;
  agreementHref: string;
  pricingHref: string;
  onAccept:(() => Promise<void>);
}>();

const pricingFields = ref<ContractPricing>();
const isLoading = ref(false);

onMounted(async () => {
  await requestHandler(UsersRequests.getContractPricing, {
    pending: isLoading,
    onSuccess: ({ account, transaction }) => {
      pricingFields.value = orderByType(Object.values({ account, transaction }).flat());
    },
  });
});
</script>

<style lang="scss" scoped>
.pricing {
  @apply w-500;

  &-footer {
    @apply flex flex-col justify-center items-center mt-48 gap-24 mb-40;

    &-agreement {
      @apply w-310 text-center text-n-black-60 text-base font-normal;
    }
  }
}
</style>
